import { render, staticRenderFns } from "./SlcCollabClearSelectionBtn.vue?vue&type=template&id=36c41778&"
import script from "./SlcCollabClearSelectionBtn.vue?vue&type=script&lang=ts&"
export * from "./SlcCollabClearSelectionBtn.vue?vue&type=script&lang=ts&"
import style0 from "./SlcCollabClearSelectionBtn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports